import type { ProLayoutProps } from '@ant-design/pro-components';
import dayjs from 'dayjs';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
  copyright: string;
  oms_title: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'LME OMS',
  copyright:`${dayjs(new Date()).format('YYYY')} LME Development Team`,
  oms_title:'',
  pwa: true,
  // logo: 'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg',
  logo: 'https://public-resource.shipdodo.com/morellato_logo-min.jpeg',
  //  logo: 'https://public-resource.shipdodo.com/shipdodo-logo-small.png',
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};

export default Settings;
